import { Loading } from 'element-ui'

let loadingInstance = null
export default {
  creatLoading(text = '加载中...') {
    loadingInstance = Loading.service({
      lock: true,
      text,
      spinner: 'el-icon-loading',
      customClass: 'custom-fullscreen-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  },
  destroyLoading() {
    loadingInstance && loadingInstance.close()
  }
}
